import { render, staticRenderFns } from "./PartnerRowController.vue?vue&type=template&id=3c92b9c2&scoped=true"
import script from "./PartnerRowController.vue?vue&type=script&lang=js"
export * from "./PartnerRowController.vue?vue&type=script&lang=js"
import style0 from "./PartnerRowController.vue?vue&type=style&index=0&id=3c92b9c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c92b9c2",
  null
  
)

export default component.exports